import CONTRATOS_ESTATUS from '@/graphql/querys/administracion/catalogos/contratosestatus/contratosEstatus.gql';
import ACTUALIZAR_CONTRATO_ESTATUS from '@/graphql/mutations/administracion/contratos/actualizarContratoEstatus.gql';
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';

export default {
  apollo: {
    contratosEstatus: {
      query: CONTRATOS_ESTATUS,
    },
  },
  methods: {
    async cambiarEstatus() {
      this.mixEsCargando();
      await this.$apollo.mutate({
        mutation: ACTUALIZAR_CONTRATO_ESTATUS,
        variables: {
          id: this.idContrato,
          idContratoEstatus: this.contratoEstatus,
        },
        update: (store, { data: { actualizarContratoEstatus } }) => {
          const query = {
            query: CONTRATO,
            variables: {
              id: this.idContrato,
            },
          };

          store.writeQuery({
            ...query,
            data: {
              contrato: actualizarContratoEstatus,
            },
          });
        },
      }).then(() => {
        this.mixMensajeSuccess();
        this.mostrarActualizarEstatus = !this.mostrarActualizarEstatus;
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.mixEsCargando();
    },
  },
  computed: {
    getContratosEstatus() {
      if (!this.contratosEstatus) return [];
      return this.contratosEstatus;
    },
  },
};
